// Function to set an item in localStorage
export const LOCAL_STORAGE_KEY = {
  changePassword: "changePassword",
  // selectedRole: "selectedRole",
  selectedRole: "a44ed839-c22a-49e6-ab36-a44574323f0c", //i'm using selected role as uuid
  email: "email",
  currentFLProjectId: "currentFLProjectId",
  cognitoIdentity:
    "CognitoIdentityServiceProvider.2ik5k86impmcgfqg3gkpcmcqvg.LastAuthUser",
  cognitoJWTIdentity: "cognitoJWTIdentity",
  userName: "userName",
  userRegion: "userRegion",
};
export function SET_LOCAL_STORAGE(key, value) {
  if (typeof value === "object" && value !== null) {
    localStorage.setItem(key, JSON.stringify(btoa(value)));
  } else {
    localStorage.setItem(key, btoa(value));
  }
}
export function GET_LOCAL_STORAGE(key) {
  const storedValue = localStorage.getItem(key);
  try {
    if (!storedValue) return storedValue; // Return null if key doesn't exist

    return atob(storedValue); // Decode Base64
  } catch (error) {
    // console.error("Error decoding Base64 from localStorage:", error);
    return storedValue; // Return null on error
  }
}

// Function to remove an item from localStorage
export function REMOVE_LOCAL_STORAGE_BY_KEY(key) {
  localStorage.removeItem(key);
}
